import type React from "react";

export const pageHeaderStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-end",
  gap: 16,
  flexWrap: "wrap",
};
export const cameraListContainerStyle: React.CSSProperties = {
  width: "100%",
  boxSizing: "border-box",
  marginTop: 28,
  border: "1px solid #eee",
  borderRadius: 14,
  padding: 20,
  background: "#fff",
};
export const cameraListHeaderStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 12,
  marginBottom: 18,
};
export const errorMessageStyle: React.CSSProperties = {
  padding: 14,
  marginBottom: 16,
  borderRadius: 10,
  background: "#fff3f3",
  border: "1px solid #ffcaca",
  color: "#a40000",
};
export const inputStyle: React.CSSProperties = {
  width: "100%",
  boxSizing: "border-box",
  padding: "10px 12px",
  borderRadius: 10,
  border: "1px solid #ddd",
  outline: "none",
  background: "#fff",
};
export const fieldLabelStyle: React.CSSProperties = {
  fontSize: 13,
  fontWeight: 800,
  marginBottom: 6,
};
export const fieldHintStyle: React.CSSProperties = {
  fontSize: 12,
  opacity: 0.7,
  marginTop: 6,
};
export const btnPrimary: React.CSSProperties = {
  padding: "10px 14px",
  borderRadius: 12,
  border: "1px solid #111",
  background: "#111",
  color: "#fff",
  fontWeight: 800,
  cursor: "pointer",
};
export const btnOutline: React.CSSProperties = {
  padding: "10px 14px",
  borderRadius: 12,
  border: "1px solid #ddd",
  background: "#fff",
  color: "#111",
  fontWeight: 800,
  cursor: "pointer",
};
export const disabledButtonStyle: React.CSSProperties = {
  cursor: "not-allowed",
  opacity: 0.6,
};
export const modalOverlay: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 16,
  zIndex: 9999,
};
export const modalCard: React.CSSProperties = {
  width: "min(980px, 100%)",
  maxHeight: "85vh",
  overflow: "auto",
  background: "#fff",
  borderRadius: 16,
  padding: 18,
  boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
};
export const modalHeaderStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 12,
};
export const modalActionsStyle: React.CSSProperties = {
  marginTop: 16,
  display: "flex",
  gap: 10,
  flexWrap: "wrap",
};
export const statusContainerStyle: React.CSSProperties = {
  marginTop: 14,
  padding: 12,
  borderRadius: 12,
  background: "#f7f7f7",
};
export const twoColumnGridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 14,
};
export const profileRowStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) auto",
  gap: 14,
  alignItems: "end",
};
export const btnX: React.CSSProperties = {
  border: "1px solid #ddd",
  background: "#fff",
  borderRadius: 10,
  padding: "6px 10px",
  cursor: "pointer",
  fontWeight: 900,
};
export const summaryGridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
  gap: 14,
  marginBottom: 22,
};
export const summaryCardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 14,
  padding: "12px 14px",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  minHeight: 105,
  boxShadow: "0 2px 8px rgba(15, 23, 42, 0.04)",
};
export const summaryLabelStyle: React.CSSProperties = {
  color: "#6b7280",
  fontSize: 13,
  fontWeight: 600,
  marginBottom: 8,
};
export const summaryValueStyle: React.CSSProperties = {
  color: "#111827",
  fontSize: 28,
  fontWeight: 800,
  lineHeight: 1,
  marginBottom: 9,
};
export const summaryDescriptionStyle: React.CSSProperties = {
  color: "#9ca3af",
  fontSize: 12,
};
export const summaryIconStyle: React.CSSProperties = {
  width: 38,
  height: 38,
  borderRadius: 11,
  border: "1px solid",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: 15,
  fontWeight: 800,
};
export const fleetPanelStyle: React.CSSProperties = {
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
  borderRadius: 18,
  padding: 20,
};
export const fleetHeaderStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 15,
  marginBottom: 18,
};
export const fleetTitleStyle: React.CSSProperties = {
  color: "#0f172a",
  fontSize: 20,
  fontWeight: 800,
};
export const fleetSubtitleStyle: React.CSSProperties = {
  color: "#64748b",
  fontSize: 13,
  marginTop: 4,
};
export const fleetResultCountStyle: React.CSSProperties = {
  color: "#2563eb",
  background: "#eff6ff",
  border: "1px solid #bfdbfe",
  borderRadius: 999,
  padding: "6px 12px",
  fontSize: 12,
  fontWeight: 700,
  whiteSpace: "nowrap",
};
export const fleetToolbarStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 12,
  marginBottom: 16,
};
export const fleetSearchWrapperStyle: React.CSSProperties = {
  position: "relative",
  flex: "1 1 320px",
  maxWidth: 500,
};
export const fleetSearchIconStyle: React.CSSProperties = {
  position: "absolute",
  left: 14,
  top: "50%",
  transform: "translateY(-50%)",
  color: "#64748b",
  fontSize: 18,
};
export const fleetSearchInputStyle: React.CSSProperties = {
  width: "100%",
  boxSizing: "border-box",
  height: 42,
  padding: "0 15px 0 42px",
  border: "1px solid #cbd5e1",
  borderRadius: 11,
  background: "#ffffff",
  color: "#0f172a",
  fontSize: 13,
  outline: "none",
};
export const fleetFiltersStyle: React.CSSProperties = {
  display: "flex",
  gap: 6,
  padding: 4,
  borderRadius: 11,
  background: "#e2e8f0",
};
export const fleetFilterButtonStyle: React.CSSProperties = {
  border: "none",
  borderRadius: 8,
  padding: "8px 14px",
  background: "transparent",
  color: "#64748b",
  fontSize: 12,
  fontWeight: 700,
  cursor: "pointer",
};
export const fleetFilterButtonActiveStyle: React.CSSProperties = {
  color: "#0f172a",
  background: "#ffffff",
  boxShadow: "0 1px 4px rgba(15, 23, 42, 0.12)",
};
export const fleetListStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 10,
};
export const fleetCameraRowStyle: React.CSSProperties = {
  position: "relative",
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 20,
  minHeight: 96,
  padding: "16px 18px 16px 24px",
  background: "#ffffff",
  border: "1px solid #e2e8f0",
  borderRadius: 14,
  boxShadow: "0 2px 7px rgba(15, 23, 42, 0.035)",
  overflow: "hidden",
  cursor: "pointer",
  transition:
    "border-color 140ms ease, box-shadow 140ms ease, transform 140ms ease",
};
export const fleetStatusRailStyle: React.CSSProperties = {
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  width: 5,
};
export const fleetCameraIdentityStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 14,
  flex: "1 1 250px",
  minWidth: 240,
};
export const fleetThumbnailStyle: React.CSSProperties = {
  width: 76,
  height: 56,
  borderRadius: 11,
  objectFit: "cover",
  display: "block",
  flexShrink: 0,
  background: "#e2e8f0",
  border: "1px solid #cbd5e1",
  boxShadow: "0 2px 6px rgba(15, 23, 42, 0.12)",
};
export const fleetThumbnailPlaceholderStyle: React.CSSProperties = {
  width: 76,
  height: 56,
  borderRadius: 11,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "1px solid #cbd5e1",
  boxShadow: "0 2px 6px rgba(15, 23, 42, 0.08)",
  flexShrink: 0,
};
export const fleetCameraIconStyle: React.CSSProperties = {
  color: "#475569",
  fontSize: 21,
};
export const fleetCameraNameWrapperStyle: React.CSSProperties = {
  minWidth: 0,
};
export const fleetCameraNameStyle: React.CSSProperties = {
  color: "#0f172a",
  fontSize: 14,
  fontWeight: 800,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};
export const fleetCameraIdStyle: React.CSSProperties = {
  color: "#94a3b8",
  fontSize: 11,
  marginTop: 4,
};
export const fleetConnectionStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 5,
  flex: "0 1 125px",
  minWidth: 120,
};
export const fleetStatusPillStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  borderRadius: 999,
  padding: "5px 9px",
  fontSize: 11,
  fontWeight: 800,
};
export const fleetOnlinePillStyle: React.CSSProperties = {
  color: "#15803d",
  background: "#f0fdf4",
  border: "1px solid #bbf7d0",
};
export const fleetOfflinePillStyle: React.CSSProperties = {
  color: "#b91c1c",
  background: "#fef2f2",
  border: "1px solid #fecaca",
};
export const fleetDisabledPillStyle: React.CSSProperties = {
  color: "#475569",
  background: "#f1f5f9",
  border: "1px solid #cbd5e1",
};
export const fleetUnknownPillStyle: React.CSSProperties = {
  color: "#a16207",
  background: "#fffbeb",
  border: "1px solid #fde68a",
};
export const fleetStatusDotStyle: React.CSSProperties = {
  width: 7,
  height: 7,
  borderRadius: "50%",
};
export const fleetConnectionTextStyle: React.CSSProperties = {
  color: "#94a3b8",
  fontSize: 10,
};
export const fleetDetailStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 5,
  flex: "1 1 130px",
  minWidth: 115,
  maxWidth: 190,
};
export const fleetDetailLabelStyle: React.CSSProperties = {
  color: "#94a3b8",
  fontSize: 10,
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: 0.5,
};
export const fleetDetailValueStyle: React.CSSProperties = {
  color: "#334155",
  fontSize: 12,
  fontWeight: 600,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};
export const fleetPlanBadgeStyle: React.CSSProperties = {
  width: "fit-content",
  maxWidth: "100%",
  padding: "5px 8px",
  borderRadius: 7,
  background: "#f1f5f9",
  color: "#475569",
  fontSize: 10,
  fontWeight: 700,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};
export const fleetActionButtonStyle: React.CSSProperties = {
  width: 34,
  height: 34,
  border: "1px solid #e2e8f0",
  borderRadius: 9,
  background: "#ffffff",
  color: "#64748b",
  fontSize: 14,
  fontWeight: 800,
  cursor: "pointer",
};
export const fleetEmptyStyle: React.CSSProperties = {
  padding: "55px 20px",
  textAlign: "center",
  background: "#ffffff",
  border: "1px dashed #cbd5e1",
  borderRadius: 14,
};
export const fleetEmptyIconStyle: React.CSSProperties = {
  color: "#94a3b8",
  fontSize: 28,
  marginBottom: 10,
};
export const fleetEmptyTitleStyle: React.CSSProperties = {
  color: "#0f172a",
  fontSize: 15,
  fontWeight: 800,
};
export const fleetEmptyDescriptionStyle: React.CSSProperties = {
  color: "#94a3b8",
  fontSize: 12,
  marginTop: 5,
};

export const cameraDetailsOverlayStyle: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  zIndex: 12000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 6,
  background: "rgba(15, 23, 42, 0.58)",
  backdropFilter: "blur(5px)",
};

export const cameraDetailsModalStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  width: "min(1420px, 98vw)",
  height: "auto",
  maxHeight: "calc(100vh - 20px)",
  overflow: "hidden",
  border: "1px solid #e2e8f0",
  borderRadius: 20,
  background: "#ffffff",
  boxShadow: "0 28px 90px rgba(15, 23, 42, 0.3)",
};

export const cameraDetailsHeaderStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 18,
  padding: "16px 20px",
  borderBottom: "1px solid #e5e7eb",
  background: "#ffffff",
};

export const cameraDetailsIdentityStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 14,
  minWidth: 0,
};

export const cameraDetailsThumbnailStyle: React.CSSProperties = {
  width: 82,
  height: 56,
  flexShrink: 0,
  objectFit: "cover",
  border: "1px solid #e2e8f0",
  borderRadius: 12,
  background: "#f8fafc",
};

export const cameraDetailsThumbnailPlaceholderStyle: React.CSSProperties = {
  width: 82,
  height: 56,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #e2e8f0",
  borderRadius: 12,
  color: "#2563eb",
  background: "linear-gradient(135deg, #eff6ff, #dbeafe)",
  fontSize: 22,
};

export const cameraDetailsTitleStyle: React.CSSProperties = {
  color: "#0f172a",
  fontSize: 22,
  fontWeight: 800,
  lineHeight: 1.2,
};

export const cameraTagRowStyle: React.CSSProperties = {
  display: "flex",
  gap: 6,
  flexWrap: "wrap",
  marginTop: 8,
};

export const cameraStatusTagStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  minHeight: 22,
  padding: "3px 8px",
  border: "1px solid",
  borderRadius: 999,
  color: "#ffffff",
  fontSize: 10,
  fontWeight: 800,
  lineHeight: 1,
};

export const cameraDetailsCloseStyle: React.CSSProperties = {
  width: 38,
  height: 38,
  flexShrink: 0,
  border: "1px solid #e2e8f0",
  borderRadius: 11,
  background: "#ffffff",
  color: "#64748b",
  fontSize: 23,
  lineHeight: 1,
  cursor: "pointer",
};

export const cameraDetailsTabsStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 6,
  padding: "10px 20px",
  borderBottom: "1px solid #e5e7eb",
  background: "#ffffff",
};

export const cameraTabStyle: React.CSSProperties = {
  minHeight: 38,
  padding: "9px 16px",
  border: "1px solid transparent",
  borderRadius: 10,
  color: "#64748b",
  background: "transparent",
  fontSize: 13,
  fontWeight: 800,
  cursor: "pointer",
};

export const cameraTabActiveStyle: React.CSSProperties = {
  border: "1px solid #dbeafe",
  color: "#1d4ed8",
  background: "#eff6ff",
  boxShadow: "0 1px 2px rgba(37, 99, 235, 0.08)",
};

export const cameraDetailsBodyStyle: React.CSSProperties = {
  flex: "1 1 auto",
  minHeight: 0,
  maxHeight: "none",
  overflowY: "auto",
  overflowX: "hidden",
  padding: 14,
  background: "#f8fafc",
};

export const cameraInfoLayoutStyle: React.CSSProperties = {
  width: "100%",
};

export const generalInfoLaunchCardStyle: React.CSSProperties = {
  width: "100%",
  display: "grid",
  gridTemplateColumns: "48px minmax(0, 1fr) auto",
  alignItems: "center",
  gap: 16,
  padding: 20,
  border: "1px solid #dbeafe",
  borderRadius: 16,
  color: "#0f172a",
  background: "linear-gradient(135deg, #ffffff, #f8fbff)",
  boxShadow: "0 5px 18px rgba(15, 23, 42, 0.06)",
  textAlign: "left",
  cursor: "pointer",
};

export const generalInfoLaunchIconStyle: React.CSSProperties = {
  width: 48,
  height: 48,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #bfdbfe",
  borderRadius: 14,
  color: "#1d4ed8",
  background: "#eff6ff",
  fontSize: 20,
  fontWeight: 900,
};

export const generalInfoLaunchTitleStyle: React.CSSProperties = {
  fontSize: 15,
  fontWeight: 850,
};

export const generalInfoLaunchDescriptionStyle: React.CSSProperties = {
  maxWidth: 650,
  marginTop: 5,
  color: "#64748b",
  fontSize: 12,
  lineHeight: 1.55,
};

export const generalInfoLaunchArrowStyle: React.CSSProperties = {
  color: "#2563eb",
  fontSize: 12,
  fontWeight: 800,
  whiteSpace: "nowrap",
};

export const generalInfoExpandedHeaderStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 14,
  padding: "18px 20px",
  borderBottom: "1px solid #e5e7eb",
  background: "linear-gradient(135deg, #ffffff, #f8fafc)",
};

export const cameraInfoSectionTitleTextStyle: React.CSSProperties = {
  color: "#0f172a",
  fontSize: 17,
  fontWeight: 850,
};

export const generalInfoExpandedSubtitleStyle: React.CSSProperties = {
  marginTop: 4,
  color: "#64748b",
  fontSize: 12,
};

export const generalInfoBackButtonStyle: React.CSSProperties = {
  padding: "9px 13px",
  border: "1px solid #cbd5e1",
  borderRadius: 10,
  color: "#334155",
  background: "#ffffff",
  fontSize: 12,
  fontWeight: 800,
  cursor: "pointer",
};

export const generalInfoContentGridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "minmax(430px, 0.95fr) minmax(500px, 1.05fr)",
  alignItems: "start",
  gap: 20,
  padding: "12px 18px 14px",
  boxSizing: "border-box",
};

export const generalInfoMainColumnStyle: React.CSSProperties = {
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gap: 0,
};

export const generalInfoVerticalListStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr)",
  gap: 0,
};

export const generalInfoVerticalItemStyle: React.CSSProperties = {
  minWidth: 0,
  display: "grid",
  gridTemplateColumns: "145px minmax(0, 1fr)",
  alignItems: "center",
  columnGap: 12,
  minHeight: 22,
  padding: "2px 4px",
  border: "none",
  background: "transparent",
};

export const generalInfoVerticalLabelStyle: React.CSSProperties = {
  color: "#475569",
  fontSize: 10,
  fontWeight: 750,
  whiteSpace: "nowrap",
  textAlign: "right",
};

export const generalInfoVerticalValueStyle: React.CSSProperties = {
  minWidth: 0,
  color: "#334155",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  textAlign: "left",
  fontSize: 10,
  fontWeight: 650,
};

export const generalInfoVerticalStatusListStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr)",
  gap: 0,
  paddingLeft: 10,
};

export const generalInfoDetailsColumnStyle: React.CSSProperties = {
  minWidth: 0,
};

export const generalInfoThumbnailColumnStyle: React.CSSProperties = {
  minWidth: 0,
};

export const generalInfoSectionLabelStyle: React.CSSProperties = {
  marginBottom: 7,
  color: "#475569",
  fontSize: 10,
  fontWeight: 850,
  letterSpacing: "0.05em",
  textTransform: "uppercase",
};

export const generalInfoListStyle: React.CSSProperties = {
  overflow: "hidden",
  marginBottom: 10,
  border: "1px solid #e2e8f0",
  borderRadius: 11,
  background: "#ffffff",
};

export const generalInfoListRowStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 10,
  minHeight: 32,
  padding: "7px 10px",
  borderBottom: "1px solid #f1f5f9",
  whiteSpace: "nowrap",
};

export const generalInfoListLabelStyle: React.CSSProperties = {
  flex: "0 0 auto",
  color: "#64748b",
  fontSize: 10,
  fontWeight: 700,
};

export const generalInfoListValueStyle: React.CSSProperties = {
  minWidth: 0,
  maxWidth: "68%",
  color: "#0f172a",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  textAlign: "right",
  fontSize: 10,
  fontWeight: 800,
};

export const generalInfoThumbnailCardStyle: React.CSSProperties = {
  overflow: "hidden",
  marginBottom: 9,
  border: "1px solid #dbe3ee",
  borderRadius: 13,
  background: "#ffffff",
  boxShadow: "0 3px 10px rgba(15, 23, 42, 0.05)",
};

export const generalInfoThumbnailStyle: React.CSSProperties = {
  width: "100%",
  height: 218,
  display: "block",
  objectFit: "cover",
  background: "#e2e8f0",
};

export const generalInfoThumbnailEmptyStyle: React.CSSProperties = {
  height: 218,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#94a3b8",
  background: "linear-gradient(135deg, #f8fafc, #e2e8f0)",
  fontSize: 13,
  fontWeight: 700,
};

export const generalInfoThumbnailFooterStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
  padding: 9,
};

export const generalInfoThumbnailNameStyle: React.CSSProperties = {
  color: "#0f172a",
  fontSize: 13,
  fontWeight: 850,
};

export const generalInfoThumbnailTimeStyle: React.CSSProperties = {
  marginTop: 3,
  color: "#94a3b8",
  fontSize: 10,
};

export const generalInfoLiveBadgeStyle: React.CSSProperties = {
  padding: "5px 8px",
  border: "1px solid #bbf7d0",
  borderRadius: 999,
  color: "#15803d",
  background: "#f0fdf4",
  fontSize: 10,
  fontWeight: 850,
};

export const generalInfoOfflineBadgeStyle: React.CSSProperties = {
  borderColor: "#fecaca",
  color: "#b91c1c",
  background: "#fef2f2",
};

export const generalInfoStatusCardStyle: React.CSSProperties = {
  marginTop: 10,
  padding: "10px 4px 4px",
  borderTop: "1px solid #e2e8f0",
  background: "transparent",
};

export const cameraInfoCardStyle: React.CSSProperties = {
  overflow: "hidden",
  border: "1px solid #e2e8f0",
  borderRadius: 16,
  background: "#ffffff",
  boxShadow: "0 2px 8px rgba(15, 23, 42, 0.04)",
  fontSize: 13,
};

export const cameraInfoSectionTitleStyle: React.CSSProperties = {
  padding: "17px 18px",
  borderBottom: "1px solid #e5e7eb",
  color: "#0f172a",
  background: "#ffffff",
  fontSize: 16,
  fontWeight: 800,
};

export const cameraInfoRowsStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: 12,
  padding: 18,
};

export const cameraInfoRowStyle: React.CSSProperties = {
  display: "block",
  minWidth: 0,
  padding: 9,
  border: "1px solid #e5e7eb",
  borderRadius: 12,
  background: "#f8fafc",
};

export const cameraInfoLabelStyle: React.CSSProperties = {
  display: "block",
  marginBottom: 6,
  color: "#64748b",
  fontSize: 11,
  fontWeight: 800,
  letterSpacing: "0.04em",
  textAlign: "left",
  textTransform: "uppercase",
};

export const cameraInfoValueStyle: React.CSSProperties = {
  display: "block",
  minWidth: 0,
  color: "#0f172a",
  overflowWrap: "anywhere",
  fontSize: 13,
  fontWeight: 700,
};

export const cameraInfoDividerStyle: React.CSSProperties = {
  height: 1,
  margin: "4px 18px 14px",
  background: "#e5e7eb",
};

export const availabilityLineStyle: React.CSSProperties = {
  width: "100%",
  boxSizing: "border-box",
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  margin: 0,
  padding: "2px 0",
  border: "none",
  background: "transparent",
  fontSize: 10,
  fontWeight: 650,
  whiteSpace: "nowrap",
};

export const analyticsHeadingStyle: React.CSSProperties = {
  margin: "0 18px 12px",
  color: "#0f172a",
  fontSize: 14,
  fontWeight: 800,
};

export const analyticsLineStyle: React.CSSProperties = {
  width: "100%",
  boxSizing: "border-box",
  display: "inline-flex",
  alignItems: "center",
  gap: 5,
  margin: 0,
  padding: "2px 0",
  border: "none",
  color: "#475569",
  background: "transparent",
  fontSize: 10,
  whiteSpace: "nowrap",
};

export const generalOverviewStyle: React.CSSProperties = {
  marginTop: 14,
  padding: 18,
  border: "1px solid #dbeafe",
  borderRadius: 16,
  background: "linear-gradient(135deg, #ffffff, #f8fbff)",
  boxShadow: "0 2px 8px rgba(15, 23, 42, 0.04)",
};

export const qualitySummaryStyle: React.CSSProperties = {
  marginTop: 14,
  padding: 18,
  border: "1px solid #dbeafe",
  borderRadius: 16,
  background: "linear-gradient(135deg, #ffffff, #f8fbff)",
  boxShadow: "0 2px 8px rgba(15, 23, 42, 0.04)",
};

export const sectionHeadingRowStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
  marginBottom: 14,
};

export const sectionEyebrowStyle: React.CSSProperties = {
  color: "#2563eb",
  fontSize: 10,
  fontWeight: 800,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
};

export const sectionTitleStyle: React.CSSProperties = {
  marginTop: 4,
  color: "#0f172a",
  fontSize: 16,
  fontWeight: 800,
};

export const sectionStatusBadgeStyle: React.CSSProperties = {
  padding: "6px 10px",
  border: "1px solid #bfdbfe",
  borderRadius: 999,
  color: "#1d4ed8",
  background: "#eff6ff",
  fontSize: 11,
  fontWeight: 800,
  whiteSpace: "nowrap",
};

export const overviewMetricGridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
  gap: 12,
};

export const qualityMetricGridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
  gap: 12,
};

export const overviewMetricStyle: React.CSSProperties = {
  minWidth: 0,
  padding: "14px 15px",
  border: "1px solid #e2e8f0",
  borderRadius: 12,
  background: "#ffffff",
};

export const overviewMetricLabelStyle: React.CSSProperties = {
  display: "block",
  marginBottom: 6,
  color: "#64748b",
  fontSize: 10,
  fontWeight: 800,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
};

export const overviewMetricValueStyle: React.CSSProperties = {
  display: "block",
  color: "#0f172a",
  fontSize: 13,
  fontWeight: 800,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const generalTabPanelStyle: React.CSSProperties = {
  width: "100%",
  padding: 0,
};

export const generalFormGridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
  gap: 18,
  padding: "22px 24px 24px",
  border: "1px solid #e2e8f0",
  borderRadius: 16,
  background: "#ffffff",
  boxShadow: "0 2px 8px rgba(15, 23, 42, 0.04)",
};

export const generalDescriptionFieldStyle: React.CSSProperties = {
  gridColumn: "1 / -1",
};

export const generalFieldStyle: React.CSSProperties = {
  display: "block",
  minWidth: 0,
  color: "#374151",
  fontSize: 14,
  fontWeight: 800,
};

export const cameraGeneralInputStyle: React.CSSProperties = {
  width: "100%",
  minHeight: 50,
  marginTop: 9,
  padding: "12px 14px",
  border: "1px solid #d1d5db",
  borderRadius: 12,
  color: "#111827",
  background: "#ffffff",
  outline: "none",
  fontSize: 14,
  fontWeight: 700,
  boxSizing: "border-box",
};

export const cameraDescriptionStyle: React.CSSProperties = {
  width: "100%",
  minHeight: 118,
  marginTop: 9,
  padding: "14px 15px",
  border: "1px solid #d1d5db",
  borderRadius: 12,
  color: "#111827",
  background: "#ffffff",
  resize: "vertical",
  fontSize: 14,
  lineHeight: 1.55,
  outline: "none",
  boxSizing: "border-box",
};

export const toggleListStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: 12,
  marginTop: 14,
};

export const toggleSettingRowStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 14,
  minHeight: 76,
  padding: "14px 16px",
  border: "1px solid #e2e8f0",
  borderRadius: 13,
  background: "#ffffff",
};

export const toggleSettingLabelStyle: React.CSSProperties = {
  color: "#0f172a",
  fontSize: 13,
  fontWeight: 800,
  textAlign: "left",
};

export const toggleSettingHelpStyle: React.CSSProperties = {
  maxWidth: 250,
  marginTop: 4,
  color: "#94a3b8",
  fontSize: 11,
  lineHeight: 1.4,
  textAlign: "left",
};

export const toggleTrackStyle: React.CSSProperties = {
  position: "relative",
  width: 38,
  height: 22,
  flexShrink: 0,
  padding: 2,
  border: "1px solid #cbd5e1",
  borderRadius: 999,
};

export const toggleThumbStyle: React.CSSProperties = {
  display: "block",
  width: 16,
  height: 16,
  borderRadius: "50%",
  background: "#ffffff",
  boxShadow: "0 1px 4px rgba(0,0,0,0.28)",
  transition: "transform 140ms ease",
};

export const qualityTabPanelStyle: React.CSSProperties = {
  width: "100%",
  padding: 0,
};

export const qualityConnectionBannerStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 14,
  marginBottom: 14,
  padding: "14px 16px",
  border: "1px solid #dbeafe",
  borderRadius: 14,
  color: "#1e3a8a",
  background: "#eff6ff",
};

export const qualityReadButtonStyle: React.CSSProperties = {
  padding: "9px 13px",
  border: "1px solid #bfdbfe",
  borderRadius: 10,
  color: "#1d4ed8",
  background: "#ffffff",
  fontSize: 12,
  fontWeight: 800,
  cursor: "pointer",
};

export const qualityFormStyle: React.CSSProperties = {
  padding: "16px 18px",
  border: "1px solid #e2e8f0",
  borderRadius: 16,
  background: "#ffffff",
  boxShadow: "0 2px 8px rgba(15, 23, 42, 0.04)",
};

export const qualityRowStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "150px minmax(0, 1fr)",
  alignItems: "center",
  gap: 18,
  minHeight: 54,
  padding: "8px 0",
  borderBottom: "1px solid #f1f5f9",
};

export const qualityRowLabelStyle: React.CSSProperties = {
  color: "#475569",
  fontSize: 13,
  fontWeight: 800,
  textAlign: "left",
};

export const qualityRowContentStyle: React.CSSProperties = {
  minWidth: 0,
};

export const qualitySelectStyle: React.CSSProperties = {
  width: "min(390px, 100%)",
  minHeight: 40,
  padding: "8px 10px",
  border: "1px solid #d1d5db",
  borderRadius: 10,
  color: "#111827",
  background: "#ffffff",
  fontSize: 12,
};

export const qualityRangeLineStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 10,
};

export const qualityRangeStyle: React.CSSProperties = {
  width: 210,
  accentColor: "#2563eb",
};

export const qualityBitrateRangeStyle: React.CSSProperties = {
  width: 210,
  accentColor: "#16a34a",
};

export const qualityRangeLimitStyle: React.CSSProperties = {
  minWidth: 24,
  color: "#2563eb",
  fontSize: 12,
  fontWeight: 700,
  textAlign: "center",
};

export const qualityBlueLabelStyle: React.CSSProperties = {
  color: "#2563eb",
  fontSize: 12,
  fontWeight: 700,
};

export const qualityNumberStyle: React.CSSProperties = {
  width: 76,
  minHeight: 38,
  padding: "7px 9px",
  border: "1px solid #d1d5db",
  borderRadius: 9,
  color: "#111827",
  fontSize: 12,
};

export const qualityUnitStyle: React.CSSProperties = {
  color: "#64748b",
  fontSize: 12,
};

export const qualityCheckLabelStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: 5,
  color: "#475569",
  fontSize: 12,
  fontWeight: 700,
};

export const qualityEmptyStyle: React.CSSProperties = {
  padding: 34,
  border: "1px dashed #bfdbfe",
  borderRadius: 15,
  color: "#64748b",
  background: "#f8fafc",
  textAlign: "center",
  fontSize: 13,
};

export const supportTabPanelStyle: React.CSSProperties = {
  display: "grid",
  gap: 14,
  width: "100%",
  alignContent: "start",
};

export const supportConnectionCardStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 18,
  minHeight: 118,
  padding: "22px 24px",
  border: "1px solid #dbeafe",
  borderRadius: 16,
  background: "linear-gradient(135deg, #eff6ff, #f8fafc)",
  boxShadow: "0 2px 8px rgba(15, 23, 42, 0.04)",
};

export const supportCardEyebrowStyle: React.CSSProperties = {
  marginBottom: 5,
  color: "#2563eb",
  fontSize: 11,
  fontWeight: 800,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
};

export const supportCardTitleStyle: React.CSSProperties = {
  color: "#0f172a",
  fontSize: 18,
  fontWeight: 800,
};

export const supportCardDescriptionStyle: React.CSSProperties = {
  marginTop: 5,
  color: "#64748b",
  fontSize: 12,
};

export const supportStatusPillsStyle: React.CSSProperties = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "flex-end",
  gap: 8,
};

export const supportSuccessPillStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: 7,
  padding: "8px 11px",
  border: "1px solid #bbf7d0",
  borderRadius: 999,
  color: "#166534",
  background: "#f0fdf4",
  fontSize: 11,
  fontWeight: 800,
};

export const supportSuccessDotStyle: React.CSSProperties = {
  width: 8,
  height: 8,
  borderRadius: "50%",
  background: "#22c55e",
};

export const supportDetailsCardStyle: React.CSSProperties = {
  minHeight: 410,
  padding: "22px 24px",
  border: "1px solid #e2e8f0",
  borderRadius: 16,
  background: "#ffffff",
  boxShadow: "0 2px 8px rgba(15, 23, 42, 0.04)",
};

export const supportDetailsHeaderStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
  marginBottom: 16,
};

export const supportDetailsTitleStyle: React.CSSProperties = {
  color: "#0f172a",
  fontSize: 16,
  fontWeight: 800,
};

export const supportDetailsSubtitleStyle: React.CSSProperties = {
  marginTop: 4,
  color: "#64748b",
  fontSize: 12,
};

export const supportDemoBadgeStyle: React.CSSProperties = {
  padding: "6px 10px",
  border: "1px solid #bfdbfe",
  borderRadius: 999,
  color: "#1d4ed8",
  background: "#eff6ff",
  fontSize: 11,
  fontWeight: 800,
};

export const supportDetailsGridStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 0,
  overflow: "hidden",
  border: "1px solid #e2e8f0",
  borderRadius: 12,
  background: "#ffffff",
};

export const supportFieldStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "minmax(125px, 0.35fr) minmax(0, 0.65fr)",
  alignItems: "center",
  gap: 12,
  minWidth: 0,
  minHeight: 52,
  padding: "8px 12px",
  borderBottom: "1px solid #f1f5f9",
};

export const supportFieldLabelStyle: React.CSSProperties = {
  display: "block",
  marginBottom: 0,
  color: "#64748b",
  fontSize: 10,
  fontWeight: 800,
  whiteSpace: "nowrap",
};

export const supportReadOnlyInputStyle: React.CSSProperties = {
  width: "100%",
  minWidth: 0,
  minHeight: 34,
  padding: "7px 9px",
  border: "1px solid transparent",
  borderRadius: 8,
  color: "#0f172a",
  background: "transparent",
  outline: "none",
  boxSizing: "border-box",
  textAlign: "right",
  fontSize: 11,
  fontWeight: 700,
  textOverflow: "ellipsis",
};

export const supportEditableInputStyle: React.CSSProperties = {
  ...supportReadOnlyInputStyle,
  border: "1px solid #93c5fd",
  color: "#0f172a",
  background: "#ffffff",
  boxShadow: "0 0 0 3px rgba(37, 99, 235, 0.08)",
};

export const supportMessageStyle: React.CSSProperties = {
  marginTop: 15,
  padding: "11px 13px",
  border: "1px solid #bbf7d0",
  borderRadius: 11,
  color: "#166534",
  background: "#f0fdf4",
  fontSize: 12,
  fontWeight: 700,
};

export const cameraDetailsFooterStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  minHeight: 66,
  padding: "12px 22px",
  borderTop: "1px solid #e5e7eb",
  background: "#ffffff",
};

export const cameraSaveButtonStyle: React.CSSProperties = {
  padding: "10px 15px",
  border: "1px solid #111827",
  borderRadius: 11,
  color: "#ffffff",
  background: "#111827",
  fontSize: 12,
  fontWeight: 800,
  cursor: "pointer",
};

export const cameraSecondaryActionButtonStyle: React.CSSProperties = {
  padding: "10px 15px",
  border: "1px solid #d1d5db",
  borderRadius: 11,
  color: "#111827",
  background: "#ffffff",
  fontSize: 12,
  fontWeight: 800,
  cursor: "pointer",
};

export const cameraCloseButtonStyle: React.CSSProperties = {
  marginLeft: "auto",
  padding: "10px 15px",
  border: "1px solid #d1d5db",
  borderRadius: 11,
  color: "#111827",
  background: "#ffffff",
  fontSize: 12,
  fontWeight: 800,
  cursor: "pointer",
};

export const cameraFooterStatusStyle: React.CSSProperties = {
  color: "#15803d",
  fontSize: 12,
  fontWeight: 700,
};
